import {
  CustomContentItemParams,
  CustomContentItemEntity,
} from "@shared/services/event_tracking/entities/custom_content/custom_content_item_entity";

export interface CustomContentProductCatalogParams extends CustomContentItemParams {
  base_state_param_type: string;
  base_state_params: object;
}

export class CustomContentProductCatalogEntity extends CustomContentItemEntity {
  base_state_param_type: string;
  base_state_params: object;

  constructor(params: CustomContentProductCatalogParams) {
    super(params);
    this.type = "custom_content_product_catalog";
    this.entity_version = 2;
    this.base_state_param_type = params.base_state_param_type;
    this.base_state_params = params.base_state_params;
  }
}
